<template>
  <!--
     作者：luoyiming
     时间：2019-10-26
     描述：商品管理-商品编辑-商品内容
    -->

  <div class="basic-setting-content pl16 pr16">
    <!--商品详情-->
    <div class="common-form">商品详情</div>
    <el-form-item label="详情类型：">
      <el-radio-group v-model="form.model.is_picture">
        <el-radio :label="0">图文</el-radio>
        <el-radio :label="1">纯图</el-radio>
      </el-radio-group>
    </el-form-item>

    <!--内容-->
    <el-form-item label="详情内容：" v-if="form.model.is_picture == 0">
      <div class="edit_container">
        <Uediter :text="form.model.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc">
        </Uediter>
      </div>
    </el-form-item>

    <el-form-item label="详情图片：" v-if="form.model.is_picture == 1">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.contentImage">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.contentImage" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                  class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="is_upload" :config="config" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--租凭说明-->
    <div class="common-form">租凭说明</div>
    <el-form-item label="详情类型：">
      <el-radio-group v-model="form.model.is_lease_description">
        <el-radio :label="0">图文</el-radio>
        <el-radio :label="1">纯图</el-radio>
      </el-radio-group>
    </el-form-item>
    <!--内容-->

    <el-form-item label="详情内容：" v-if="form.model.is_lease_description == 0">
      <div class="edit_container">
        <Uediters :text="form.model.lease_description" :config="ueditors.config" ref="ue"
          @contentChange="contentChangeFuncs"></Uediters>
      </div>
    </el-form-item>

    <el-form-item label="详情图片：" v-if="form.model.is_lease_description == 1">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.leaseImage">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.leaseImage" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgs(index)"><i
                  class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openUploads"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>



    <!--租凭说明图片组件-->
    <Uploads v-if="is_uploads" :config="config" :isupload="is_uploads" @returnImgs="returnImgsFuncs">上传图片</Uploads>



    <!--常用说明-->
    <div class="common-form">常用说明</div>
    <el-form-item label="详情类型：">
      <el-radio-group v-model="form.model.is_common_description">
        <el-radio :label="0">图文</el-radio>
        <el-radio :label="1">纯图</el-radio>
      </el-radio-group>
    </el-form-item>

    <!--内容-->
    <el-form-item label="详情内容：" v-if="form.model.is_common_description == 0">
      <div class="edit_container">
        <Uediterss :text="form.model.common_description" :config="ueditorss.config" ref="ue"
          @contentChange="contentChangeFuncss"></Uediterss>
      </div>
    </el-form-item>

    <el-form-item label="详情图片：" v-if="form.model.is_common_description == 1">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.commonImage">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.commonImage" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgss(index)"><i
                  class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openUploadss"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <!--常用说明图片组件-->
    <Uploadss v-if="is_uploadss" :config="config" :isupload="is_uploadss" @returnImgs="returnImgsFuncss">上传图片</Uploadss>
  </div>
</template>



<script>

import Uediter from '@/components/UE.vue';
import Uediters from '@/components/UE.vue';
import Uediterss from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import Uploadss from '@/components/file/Upload';
import Uploads from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    /*编辑器*/
    Uediter,
    Uediters,
    Uediterss,
    Upload,
    Uploads,
    draggable,
    Uploadss,

  },

  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      ueditors: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      ueditorss: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      is_upload: false,
      is_uploads: false,
      is_uploadss: false,
      config: {
        total: 9, file_type: 'image',
      },
    };
  },

  created() {
    console.log(this.form, '1111111111')
    //this.ueditor.text = this.form.model.content;
  },
  inject: ['form'],
  methods: {
    /*获取富文本框内容*/
    getContent: function () {
      //return this.$refs.ue.getUEContent();
    },
    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.model.content = e;
    },
    openUpload() {
      this.is_upload = true;
    },
    /*上传商品图片*/
    returnImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.contentImage.concat(e);
        this.$set(this.form.model, 'contentImage', imgs);
      }
      this.is_upload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.contentImage.splice(index, 1);
    },

    /*租聘*/
    openUploads() {
      this.is_uploads = true;
    },
    /*租聘商品图片*/

    returnImgsFuncs(e) {
      console.log(e, "*************88888")
      if (e != null) {
        let imgs = this.form.model.leaseImage.concat(e);
        this.$set(this.form.model, 'leaseImage', imgs);
      }
      this.is_uploads = false;
    },

    /*删除租聘商品图片*/
    deleteImgs(index) {
      this.form.model.leaseImage.splice(index, 1);
    },
    /*获取租聘富文本内容*/
    contentChangeFuncs(e) {
      this.form.model.lease_description = e;
    },
    // 常用说明
    openUploadss() {
      this.is_uploadss = true;
    },

    /*常用说明商品图片*/
    returnImgsFuncss(e) {
      console.log(e, "*************")
      if (e != null) {
        let imgs = this.form.model.commonImage.concat(e);
        this.$set(this.form.model, 'commonImage', imgs);
      }
      this.is_uploadss = false;
    },
    /*删除常用说明商品图片*/
    deleteImgss(index) {
      this.form.model.commonImage.splice(index, 1);
    },
    /*获取常用说明富文本内容*/
    contentChangeFuncss(e) {
      this.form.model.common_description = e;
    },
  }
};
</script>



<style>

</style>



// WEBPACK FOOTER //
// src/views/product/recovery/commodity/part/Content.vue